export default {
    data() {
        return {
            feature: [{
                title: '统一标准',
                numberPic: require("../../assets/icons/num1.png"),
                text: '数字基座通过统一的数据标准（如数据字典、接口规范）和数据中台，将分散在各系统的数据整合、清洗、关联，形成全校统一的 “数据资产池”。'
            }, {
                title: '技术中台',
                numberPic: require("../../assets/icons/num2.png"),
                text: '提供统一认证，统一消息，统一流程引擎、统一技术组件，为各业务部门及应用系统提供统一技术中台服务。'
            }, {
                title: '一屏可视',
                numberPic: require("../../assets/icons/num3.png"),
                text: '为学校管理层提供 “数据可视化” 的决策支持，推动管理从 “经验驱动” 向 “数据驱动” 转变。'
            }, {
                title: '一站服务',
                numberPic: require("../../assets/icons/num4.png"),
                text: '整合全校服务资源，构建 “一站式服务平台”，让师生无需在多个系统间切换，即可办理各类业务。'
            }],
        }
    },
    created() {

    },
}